/*
 * @Author       : shenqing
 * @desc         : 组件描述
 * @Date         : 2024-07-09 14:11:57
 * @LastEditTime : 2025-11-18 13:55:23
 * @LastEditors  : QLing
 * @FilePath     : /evalute-all/teaching_QualityService/src/router/index.js
 */
/* eslint-disable quotes */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// 面包屑跟路由相关，保证路由有meta: { title: '' }属性，并且跟左侧菜单名称保持一致
let routes = {
    routes: [
        {
            path: '/',
            redirect: '/use/home'
        },
        {
            path: '/login',
            redirect: '/login/sail'
        },
        {
            path: '/login/:name',
            meta: {
                title: '登录页'
            },
            name: 'login',
            component: resolve => require(['components/login'], resolve)
        },
        {
            path: '/index',
            meta: {
                title: '',
                keepAlive: true
            },
            name: 'index',
            component: resolve => require(['components/index/index'], resolve),
            children: [
                // 监控
                // 实时-教室课堂状态
                {
                    path: '/index/control/nowClass',
                    meta: {
                        title: '实时-教室课堂状态'
                    },
                    name: 'nowClass',
                    component: resolve => require(['view/control/now/nowClass/nowClass'], resolve)
                },
                // 实时-教室课堂状态-楼栋
                {
                    path: '/index/control/nowClass/nowFollow',
                    meta: {
                        title: '实时-教室课堂状态-楼栋',
                        keepAlive: true
                    },
                    name: 'nowFollow',
                    component: resolve => require(['view/control/now/nowClass/nowFollow'], resolve)
                },
                // 实时-教室课堂状态-教室
                {
                    path: '/index/control/nowClassroom',
                    meta: {
                        title: '实时-教室课堂状态-教室'
                    },
                    name: 'nowClassroom',
                    component: resolve => require(['view/control/now/nowClass/nowClassroom'], resolve)
                },
                // 实时-教学运行状态
                {
                    path: '/index/control/nowRun',
                    meta: {
                        title: '实时-教学运行状态'
                    },
                    name: 'nowRun',
                    component: resolve => require(['view/control/now/nowRun/nowRun'], resolve)
                },
                // 实时-教学互动状态
                {
                    path: '/index/control/nowInteract',
                    meta: {
                        title: '实时-教学互动状态'
                    },
                    name: 'nowInteract',
                    component: resolve => require(['view/control/now/nowInteract/nowInteract'], resolve)
                },
                // 实时-教学评价状态
                {
                    path: '/index/control/nowEvaluate',
                    meta: {
                        title: '实时-教学评价状态'
                    },
                    name: 'nowEvaluate',
                    component: resolve => require(['view/control/now/nowEvaluate/nowEvaluate'], resolve)
                },
                // 实时-教学资源状态
                {
                    path: '/index/control/nowResource',
                    meta: {
                        title: '实时-教学资源状态'
                    },
                    name: 'nowResource',
                    component: resolve => require(['view/control/now/nowResource/nowResource'], resolve)
                },
                // 周-教学运行状态
                {
                    path: '/index/control/weekRun',
                    meta: {
                        title: '周-教学运行状态'
                    },
                    name: 'weekRun',
                    component: resolve => require(['view/control/week/weekRun/weekRun'], resolve)
                },
                // 周-教学互动状态
                {
                    path: '/index/control/weekInteract',
                    meta: {
                        title: '周-教学互动状态'
                    },
                    name: 'weekInteract',
                    component: resolve => require(['view/control/week/weekInteract/weekInteract'], resolve)
                },
                // 周-教学资源状态
                {
                    path: '/index/control/weekResource',
                    meta: {
                        title: '周-教学资源状态'
                    },
                    name: 'weekResource',
                    component: resolve => require(['view/control/week/weekResource/weekResource'], resolve)
                },
                // 周-教学评价状态
                {
                    path: '/index/control/weekEvaluate',
                    meta: {
                        title: '周-教学评价状态'
                    },
                    name: 'weekEvaluate',
                    component: resolve => require(['view/control/week/weekEvaluate/weekEvaluate'], resolve)
                },
                // 学期-教学运行状态
                {
                    path: '/index/control/treamRun',
                    meta: {
                        title: '学期-教学运行状态'
                    },
                    name: 'treamRun',
                    component: resolve => require(['view/control/tream/treamRun/treamRun'], resolve)
                },
                // 学期-教学互动状态
                {
                    path: '/index/control/treamInteract',
                    meta: {
                        title: '学期-教学互动状态'
                    },
                    name: 'treamInteract',
                    component: resolve => require(['view/control/tream/treamInteract/treamInteract'], resolve)
                },
                // 学期-教学资源状态
                {
                    path: '/index/control/treamResource',
                    meta: {
                        title: '学期-教学资源状态'
                    },
                    name: 'treamResource',
                    component: resolve => require(['view/control/tream/treamResource/treamResource'], resolve)
                },
                // 学期-教学评价状态
                {
                    path: '/index/control/treamEvaluate',
                    meta: {
                        title: '学期-教学评价状态'
                    },
                    name: 'treamEvaluate',
                    component: resolve => require(['view/control/tream/treamEvaluate/treamEvaluate'], resolve)
                },
                // 个人中心
                {
                    path: '/index/moni',
                    meta: {
                        title: '首页'
                    },
                    name: 'centre',
                    component: resolve => require(['view/center/home--'], resolve)
                },
                {
                    path: '/index/analyse',
                    meta: {
                        title: '学期教学概况',
                        keepAlive: true
                    },
                    name: 'analyseIndex',
                    component: resolve => require(['view/analyse/home'], resolve)
                },
                {
                    path: '/index/analyse/home',
                    meta: {
                        title: '学期教学概况',
                        keepAlive: true
                    },
                    name: 'analyse',
                    component: resolve => require(['view/analyse/home'], resolve)
                },
                {
                    path: '/index/analyse/single',
                    meta: {
                        title: '单个课程分析'
                    },
                    name: 'single',
                    component: resolve => require(['view/analyse/single/single'], resolve)
                },
                {
                    path: '/index/analyse/more',
                    meta: {
                        title: '多课程横向对比分析'
                    },
                    name: 'more',
                    component: resolve => require(['view/analyse/more/more'], resolve)
                },
                {
                    path: '/index/analyse/report',
                    meta: {
                        title: '教师课程自我诊改报告'
                    },
                    name: 'report',
                    component: resolve => require(['view/analyse/report/report'], resolve)
                },
                {
                    path: '/index/analyse/report-write',
                    meta: {
                        title: '教师课程自我诊改报告填写'
                    },
                    name: 'report-write',
                    component: resolve => require(['view/analyse/report/write'], resolve)
                },
                // 监控分析 外链地址
                {
                    path: '/supervising',
                    name: '监控分析',
                    component: resolve => require(['view/supervising/supervising.vue'], resolve),
                    meta: {
                        title: '数据分析中心'
                    }
                },
                {
                    // 考勤
                    path: '/supervising/clockingIn/:id',
                    name: 'clockingIn',
                    component: () => import('@/view/supervising/components/evaluation/clockingIn/clockingIn')
                },
                {
                    // 学生参评率
                    path: '/supervising/stujoinprecent/:id',
                    name: 'stujoinprecent',
                    component: () => import('@/view/supervising/components/evaluation/student-evaluation/stujoinprecent')
                },
                {
                    // 指标分析（领导评教、同行评教、督导评教）
                    path: '/supervising/indexanalysis/:id',
                    name: 'indexanalysis',
                    component: () => import('@/view/supervising/components/evaluation/index-analysis/index-analysis')
                },
                {
                    // 得分统计（领导评教、同行评教、督导评教）
                    path: '/supervising/scoreStatistics/:id',
                    name: 'scoreStatistics',
                    component: () => import('@/view/supervising/components/evaluation/score-statistics/score-statistics')
                },
                {
                    // 历学期学生评教/历学期督导评教/历学期领导评教/历学期同行评教得分分布纵向对比分析
                    path: '/supervising/verticalAnalysis/:id',
                    name: 'verticalAnalysis',
                    component: () => import('@/view/supervising/components/dataSumAnalysis/verticalAnalysis')
                },
                {
                    // 历学期学生评教/历学期督导评教/历学期领导评教/历学期同行评教得分分布纵向对比分析
                    path: '/supervising/stuEvalKpi/:id',
                    name: 'stuEvalKpi',
                    component: () => import('@/view/supervising/components/stuEvalKpi/stuEvalKpi')
                },
                {
                    // 学生评教标签分析
                    path: '/supervising/studentEvaLable/:id',
                    name: 'studentEvaLable',
                    component: () => import('@/view/supervising/components/evaluation/student-eva-lable/student-eva-lable')
                },
                {
                    // 信息员评价教师得分
                    path: '/supervising/messageteacherscore/:id',
                    name: 'messageteacherscore',
                    component: () => import('@/view/supervising/components/messageteacherscore/messageteacherscore')
                },
                {
                    // 信息员评价课程得分
                    path: '/supervising/messageclassscore/:id',
                    name: 'messageclassscore',
                    component: () => import('@/view/supervising/components/messageclassscore/messageclassscore')
                },
                {
                    // 学生评教（教师报告)
                    path: '/supervising/reportStatistics/:id',
                    name: 'reportStatistics',
                    component: () => import('@/view/supervising/components/evaluation/teacher-report/report-statistics')
                },
                {
                    // 学生评教 （7条新增）
                    path: '/supervising/stuEvaluation/:id',
                    name: 'stuEvaluation',
                    component: () => import('@/view/supervising/components/evaluation/stuEvaluation/stuEvaluation')
                },
                {
                    // 问卷调查参与率
                    path: '/supervising/questionnaire/QUES_PARTICIPATE_RATE',
                    name: 'QUES_PARTICIPATE_RATE',
                    component: () => import('@/view/supervising/components/questionnaire/que_join')
                },
                {
                    // 问卷调查参与率明细
                    path: '/supervising/questionnaire/QUES_PARTICIPATE_RATE_DETAIL',
                    name: 'QUES_PARTICIPATE_RATE_DETAIL',
                    component: () => import('@/view/supervising/components/questionnaire/que_join_info')
                },
                {
                    // 问卷调查(数据分析)
                    path: '/supervising/questionnaire/QUES_DATA_ANALYSE',
                    name: 'QUES_DATA_ANALYSE',
                    component: () => import('@/view/supervising/components/questionnaire/que_summary')
                },
                {
                    // 毕业生满意度调查（参与率）
                    path: '/supervising/questionnaire/QUES_GRADUATE_PARTICIPATE_RATE',
                    name: 'QUES_GRADUATE_PARTICIPATE_RATE',
                    component: () => import('@/view/supervising/components/questionnaire/bys_join')
                },
                // 之前不合理 也不想改 脑阔痛
                {
                    // 毕业生满意度调查（参与率）
                    path: '/supervising/questionnaire/QUES_GRADUATE_STATISFACTION_SCHOOL',
                    name: 'QUES_GRADUATE_STATISFACTION_SCHOOL',
                    component: () => import('@/view/supervising/components/questionnaire/bys_join')
                },
                // 之前不合理 也不想改 脑阔痛
                {
                    // 毕业生满意度调查（院系满意度）
                    path: '/supervising/questionnaire/QUES_GRADUATE_STATISFACTION_COLLEGE',
                    name: 'QUES_GRADUATE_STATISFACTION_COLLEGE',
                    component: () => import('@/view/supervising/components/questionnaire/bys_join')
                },
                // 之前不合理 也不想改 脑阔痛
                {
                    // 毕业生满意度调查（专业满意度）
                    path: '/supervising/questionnaire/QUES_GRADUATE_STATISFACTION_MAJOR',
                    name: 'QUES_GRADUATE_STATISFACTION_MAJOR',
                    component: () => import('@/view/supervising/components/questionnaire/bys_join')
                },
                {
                    // 毕业生满意度调查（数据分析）
                    path: '/supervising/questionnaire/QUES_GRADUATE_DATA_ANALYSE',
                    name: 'QUES_GRADUATE_DATA_ANALYSE',
                    component: () => import('@/view/supervising/components/questionnaire/bys_summary')
                },
                {
                    // 教师教学资源分析
                    path: '/supervising/teachResource/TEACHINGRESOURCE_TEA',
                    name: 'TEACHINGRESOURCE_TEA',
                    component: () => import('@/view/supervising/components/teachResource/teach_analysis')
                },
                {
                    // 教师教学资源使用分析
                    path: '/supervising/teachResource/TEACHINGRESOURCE_TEA_USE',
                    name: 'TEACHINGRESOURCE_TEA_USE',
                    component: () => import('@/view/supervising/components/teachResource/teach_useAnalysis')
                },
                {
                    // 课堂互动分析
                    path: '/supervising/courseInteract/TEACHINGINTERACTION_CLASSROOM',
                    name: 'TEACHINGINTERACTION_CLASSROOM',
                    component: () => import('@/view/supervising/components/courseInteract/interactAnalysis')
                },
                {
                    // 实习评价
                    path: '/supervising/entEval/:id',
                    name: 'entEval',
                    component: () => import('@/view/supervising/components/entEval/index')
                },
                {
                    // 评课进度（领导评教、同行评教、督导评教）
                    path: '/supervising/lessonProgress/:id',
                    name: 'lessonProgress',
                    component: () => import('@/view/supervising/components/evaluation/lesson-progress/lesson-progress')
                },
                {
                    // 评课记录（领导评教、同行评教、督导评教）
                    path: '/supervising/lessonRecord/:id',
                    name: 'lessonRecord',
                    component: () => import('@/view/supervising/components/evaluation/lesson-record/lesson-record')
                },
                {
                    // 教学质量评价各教师得分汇总、听评课汇总
                    path: '/supervising/scoreSummary/:id',
                    name: 'scoreSummary',
                    component: () => import('@/view/supervising/components/dataSumAnalysis/scoreSummary')
                },
                {
                    // 教师/课程评价得分异常
                    path: '/supervising/abnormal/:id',
                    name: 'abnormal',
                    component: () => import('@/view/supervising/components/abnormal/index')
                },
                {
                    // 全校概况
                    path: '/supervising/qualityEvaluation/:id',
                    name: 'qualityEvaluationIndex',
                    component: () => import('@/view/supervising/components/qualityEvaluation/index')
                },
                {
                    // 学校教学质量分析报告
                    path: '/supervising/analysisReport/:id',
                    name: 'analysisReport',
                    component: () => import('@/view/supervising/components/analysisReport/index')
                },
                {
                    // 汇总分析 （4条新增）
                    path: '/supervising/pooledAnalysis/:id',
                    name: 'pooledAnalysis',
                    component: () => import('@/view/supervising/components/evaluation/pooledAnalysis/pooledAnalysis')
                },
                {
                    // 汇总分析-教师综合得分教研室
                    path: '/supervising/teaching/:id',
                    name: 'teaching',
                    component: () => import('@/view/supervising/components/pooledAll/teaching/teaching')
                },
                {
                    // 评教综合对比分析
                    path: '/supervising/compareAnalysis/:id',
                    name: 'compareAnalysis',
                    component: () => import('@/view/supervising/components/dataSumAnalysis/compareAnalysis')
                },
                {
                    // 教师历年对比分析
                    path: '/supervising/yearAnalysis/:id',
                    name: 'yearAnalysis',
                    component: () => import('@/view/supervising/components/yearAnalysis/index')
                },
                {
                    // 学生评价有效性分析
                    path: '/supervising/studentEvaluate/:id',
                    name: 'studentEvaluate',
                    component: () => import('@/view/supervising/components/studentEvaluate/index')
                },
                {
                    // 学生评价各年级打分
                    path: '/supervising/studentEvalGrade/:id',
                    name: 'studentEvalGrade',
                    component: () => import('@/view/supervising/components/studentEvalGrade/index')
                },
                {
                    // 历史评教信息查询
                    path: '/supervising/history/:id',
                    name: 'qualityEvaluationTableList',
                    component: () => import('@/view/supervising/components/qualityEvaluation/tableList')
                },
                {
                    // 学生评教、督导评教、领导评教、同行评教得分分布
                    path: '/supervising/scoreDistribute/:id',
                    name: 'scoreDistribute',
                    component: () => import('@/view/supervising/components/dataSumAnalysis/scoreDistribute')
                },
                {
                    // 汇总分析-教师课程得分汇总
                    path: '/supervising/tchCourseScore/:id',
                    name: 'tchCourseScore',
                    component: () => import('@/view/supervising/components/evaluation/tch-course-score/tch-course-score')
                },
                {
                    //未评价
                    path: '/supervising/evaluate/:id',
                    name: 'evaluate',
                    component: () => import('@/view/supervising/components/evaluate/evaluate')
                },
                {
                    // 教师评学
                    path: '/supervising/teacherAppreciable/:id',
                    name: 'teacherAppreciable',
                    component: () => import('@/view/supervising/components/evaluation/teachers-learn/teacherAppreciable')
                },
                {
                    // 教师评学
                    path: '/supervising/HIGHWORDS',
                    name: 'teacherAppreciable',
                    component: () => import('@/view/supervising/components/evaluation/teachers-learn/high-words.vue')
                },
                {
                    // 督导工作记录表汇总
                    path: '/supervising/workRecordSummary/WORKRECORD_SUPERVIOR',
                    name: 'workRecordSummary',
                    component: () => import('@/view/supervising/components/evaluation/work-record-summary/work-record-summary.vue')
                },
                {
                    // 教师改进报告统计
                    path: '/supervising/tchImprovedReport',
                    name: 'tchImprovedReport',
                    component: () => import('@/view/supervising/components/evaluation/improved-report-statistics/tch-improved-report.vue')
                },
                {
                    // 教师自评报告
                    path: '/supervising/tchSelfEvaluationReport',
                    name: 'tchSelfEvaluationReport',
                    component: () => import('@/view/supervising/components/evaluation/tch-selfEvaluation-report/tch-selfEvaluation-report.vue')
                },
                {
                    path: '/supervising/aiShcoolAnalysisList',
                    name: 'aiShcoolAnalysisList',
                    meta: {
                        title: 'AI 学校教学质量分析'
                    },
                    component: () => import('@/view/supervising/components/qualityAnalysis/ai-shcool-analysis/shcool-analysis-list.vue')
                },
                {
                    path: '/supervising/aiShcoolAnalysis/:type',
                    name: 'aiShcoolAnalysis',
                    meta: {
                        title: 'AI 学校教学质量分析',
                        menuPath: '/supervising/aiShcoolAnalysisList',
                        back: true
                    },
                    component: () => import('@/view/supervising/components/qualityAnalysis/ai-shcool-analysis/ai-shcool-analysis.vue')
                },
                {
                    path: '/supervising/aiSecondaryCollegeAnalysisList',
                    name: 'aiSecondaryCollegeAnalysisList',
                    meta: {
                        title: 'AI 开课部门教学质量分析'
                    },
                    component: () => import('@/view/supervising/components/qualityAnalysis/ai-secondary-college-analysis/secondary-college-analysis-list.vue')
                },
                {
                    path: '/supervising/aiSecondaryCollegeAnalysis/:type',
                    name: 'aiSecondaryCollegeAnalysis',
                    meta: {
                        title: 'AI 开课部门教学质量分析',
                        menuPath: '/supervising/aiSecondaryCollegeAnalysisList',
                        back: true
                    },
                    component: () => import('@/view/supervising/components/qualityAnalysis/ai-secondary-college-analysis/ai-secondary-college-analysis.vue')
                },
                {
                    path: '/supervising/aiMajorTeachingAnalysisList',
                    name: 'aiMajorTeachingAnalysisList',
                    meta: {
                        title: 'AI 专业教学质量分析'
                    },
                    component: () => import('@/view/supervising/components/qualityAnalysis/ai-major-teaching-analysis/major-teaching-analysis-list.vue')
                },
                {
                    path: '/supervising/aiMajorTeachingAnalysis/:type',
                    name: 'aiMajorTeachingAnalysis',
                    meta: {
                        title: 'AI 专业教学质量分析',
                        menuPath: '/supervising/aiMajorTeachingAnalysisList',
                        back: true
                    },
                    component: () => import('@/view/supervising/components/qualityAnalysis/ai-major-teaching-analysis/ai-major-teaching-analysis.vue')
                },
                {
                    path: '/supervising/aiTeacherTeachingAnalysisList',
                    name: 'aiTeacherTeachingAnalysisList',
                    meta: {
                        title: 'AI 教师教学质量分析'
                    },
                    component: () => import('@/view/supervising/components/qualityAnalysis/ai-teacher-teaching-analysis/teacher-teaching-analysis-list.vue')
                },
                {
                    path: '/supervising/aiTeacherTeachingAnalysis/:type',
                    name: 'aiTeacherTeachingAnalysis',
                    meta: {
                        title: 'AI 教师教学质量分析',
                        menuPath: '/supervising/aiTeacherTeachingAnalysisList',
                        back: true
                    },
                    component: () => import('@/view/supervising/components/qualityAnalysis/ai-teacher-teaching-analysis/ai-teacher-teaching-analysis.vue')
                }
            ]
        },
        // 资源 外链地址
        {
            path: '/resource',
            name: '资源'
        },
        // 应用
        {
            path: '/use/home',
            meta: {
                title: '应用',
                keepAlive: true
            },
            name: 'home',
            component: resolve => require(['view/uses/home'], resolve)
        },
        {
            path: '/use/allcontent',
            meta: {
                title: ''
            },
            name: 'allcontent',
            component: resolve => require(['view/uses/allcontent'], resolve),
            children: [
                {
                    path: '/use/allcontent/Attend/:name',
                    meta: {
                        title: ''
                    },
                    name: 'Attend',
                    component: resolve => require(['view/uses/attend/all-content-Attend'], resolve)
                },
                {
                    path: '/use/allcontent/record',
                    meta: {
                        title: '听评课记录'
                    },
                    name: 'record',
                    component: resolve => require(['view/uses/record/all-content-record'], resolve)
                },
                {
                    path: '/use/allcontent/questionnaire',
                    meta: {
                        title: '问卷调查'
                    },
                    name: 'questionnaire',
                    component: resolve => require(['view/uses/questionnaire/all-content-questionnaire'], resolve)
                },
                {
                    path: '/use/allcontent/workload/:type',
                    meta: {
                        title: ''
                    },
                    name: 'workload',
                    component: resolve => require(['view/uses/workload/all-content-workload'], resolve)
                },
                {
                    path: '/use/allcontent/myTask',
                    meta: {
                        title: '我的任务'
                    },
                    name: 'myTask',
                    component: resolve => require(['view/uses/myTask/all-content-myTask'], resolve)
                },
                {
                    path: '/use/allcontent/draw',
                    meta: {
                        title: '领取任务'
                    },
                    name: 'draw',
                    component: resolve => require(['view/uses/drawTask/all-content-draw'], resolve)
                },
                {
                    path: '/use/allcontent/patrolTasks/index',
                    name: 'patrolTasksIndex',
                    component: resolve => require(['view/uses/patrolTasks/index'], resolve),
                    meta: {
                        title: ''
                    }
                },
                {
                    path: '/use/allcontent/patrolTasks',
                    meta: {
                        title: '考试巡查'
                    },
                    name: 'patrolTasks',
                    component: resolve => require(['view/uses/patrolTasks/patrolTasks'], resolve)
                },
                //巡考任务-分配任务
                {
                    path: '/use/allcontent/assignTasks',
                    meta: {
                        title: '分配任务'
                    },
                    name: 'assignTasks',
                    component: resolve => require(['view/uses/patrolTasks/assignTasks'], resolve)
                },
                //巡考任务-督导任务列表
                {
                    path: '/use/allcontent/leaderList',
                    meta: {
                        title: '考试巡查督导任务列表'
                    },
                    name: 'leaderList',
                    component: resolve => require(['view/uses/patrolTasks/leaderList'], resolve)
                },
                //巡考任务-巡考记录
                {
                    path: '/use/allcontent/patrolRecord',
                    meta: {
                        title: '巡考记录'
                    },
                    name: 'patrolRecord',
                    component: resolve => require(['view/uses/patrolTasks/patrolRecord'], resolve)
                },
                //巡课任务-任务列表
                {
                    path: '/use/allcontent/patrolInquiry',
                    meta: {
                        title: '教学秩序巡查'
                    },
                    name: 'patrolInquiry',
                    component: resolve => require(['view/uses/patrolInquiry/patrolTasks'], resolve)
                },
                //巡课任务-分配任务
                {
                    path: '/use/patrolInquiry/assignTasks',
                    meta: {
                        title: '分配任务'
                    },
                    name: 'assignTasks',
                    component: resolve => require(['view/uses/patrolInquiry/assignTasks'], resolve)
                },
                //巡课任务-督导任务列表
                {
                    path: '/use/patrolInquiry/leaderList',
                    meta: {
                        title: '教学秩序巡查督导任务列表'
                    },
                    name: 'leaderList',
                    component: resolve => require(['view/uses/patrolInquiry/leaderList'], resolve)
                },
                //巡课任务-巡课记录
                {
                    path: '/use/patrolInquiry/patrolRecord',
                    meta: {
                        title: '巡课记录'
                    },
                    name: 'patrolRecord',
                    component: resolve => require(['view/uses/patrolInquiry/patrolRecord'], resolve)
                },
                //督导专项听课任务管理-任务列表
                {
                    path: '/use/allcontent/patrolLeader',
                    meta: {
                        title: '督导专项听课任务管理'
                    },
                    name: 'patrolLeader',
                    component: resolve => require(['view/uses/patrolLeader/patrolTasks'], resolve)
                },
                //督导专项听课任务管理-督导专项听课任务分配
                {
                    path: '/use/patrolLeader/leaderList',
                    meta: {
                        title: '督导专项听课任务分配'
                    },
                    name: 'patrolLeaderleaderList',
                    component: resolve => require(['view/uses/patrolLeader/leaderList'], resolve)
                },
                //督导专项听课任务管理-督导专项听课任务分配表
                {
                    path: '/use/patrolLeader/addTasksList',
                    meta: {
                        title: '督导专项听课任务分配表'
                    },
                    name: 'addTasksList',
                    component: resolve => require(['view/uses/patrolLeader/addTasksList'], resolve)
                },
                //督导专项听课任务管理-添加任务
                {
                    path: '/use/patrolLeader/assignTasks',
                    meta: {
                        title: '添加任务'
                    },
                    name: 'patrolLeaderassignTasks',
                    component: resolve => require(['view/uses/patrolLeader/assignTasks'], resolve)
                },
                //督导专项听课任务管理-添加任务
                {
                    path: '/use/allcontent/patrolLeaderRecord',
                    meta: {
                        title: '督导专项听课任务'
                    },
                    name: 'patrolLeaderRecord',
                    component: resolve => require(['view/uses/patrolLeaderRecord/patrolTasks'], resolve)
                },
                {
                    path: '/use/allcontent/evaluate',
                    meta: {
                        title: ''
                    },
                    name: 'evaluate',
                    component: resolve => require(['view/uses/evaluates/all-content-evaluate'], resolve)
                },
                {
                    path: '/use/allcontent/focusTeacher',
                    meta: {
                        title: '重点关注教师'
                    },
                    name: 'focusTeacher',
                    component: resolve => require(['view/uses/focusTeacher/index'], resolve)
                },
                {
                    path: '/use/allcontent/focusCourse',
                    meta: {
                        title: '重点关注课程'
                    },
                    name: 'focusCourse',
                    component: resolve => require(['view/uses/focusCourse/index'], resolve)
                },
                {
                    path: '/use/allcontent/useNotEvalTch',
                    meta: {
                        title: ''
                    },
                    name: 'useNotEvalTch',
                    component: resolve => require(['view/uses/useNotEvalTch/index'], resolve)
                },
                {
                    path: '/use/allcontent/onlineFeedback',
                    meta: {
                        title: '在线反馈处理'
                    },
                    name: 'onlineFeedback',
                    component: resolve => require(['view/uses/onlineFeedback/index'], resolve)
                },
                {
                    path: '/use/allcontent/courseOpenWeek',
                    name: 'courseOpenWeek',
                    component: resolve => require(['view/uses/courseOpenWeek/courseOpenWeek.vue'], resolve),
                    meta: {
                        title: '课程开课周次查询'
                    }
                },
                {
                    path: '/use/allcontent/evaluateSelf',
                    meta: {
                        title: '教师自评列表'
                    },
                    name: 'evaluateSelf',
                    component: resolve => require(['view/uses/evaluateSelf/self-evaluate-list'], resolve)
                },
                {
                    path: '/use/stuEvalTch',
                    meta: {
                        title: '学生评教'
                    },
                    name: 'stuEvalTch',
                    component: resolve => require(['view/uses/stuEvalTch/stu-eval-tch-index.vue'], resolve)
                },
                {
                    path: '/use/allcontent/teacher-questionnaire',
                    name: 'teacherQuestionnaire',
                    component: resolve => require(['view/uses/teacher-questionnaire/teacher-questionnaire'], resolve),
                    meta: {
                        title: '教师问卷'
                    }
                },
                {
                    path: '/use/allcontent/teacher-questionnaire/update',
                    name: 'teacherQuestionnaireUpdate',
                    component: resolve => require(['view/uses/teacher-questionnaire/teacher-questionnaire-update'], resolve),
                    meta: {
                        title: ''
                    }
                },
                {
                    path: '/use/allcontent/teacher-questionnaire/result',
                    name: 'teacherQuestionnaireResult',
                    component: resolve => require(['view/uses/teacher-questionnaire/teacher-questionnaire-result'], resolve),
                    meta: {
                        title: '查看问卷结果'
                    }
                },
                {
                    path: '/use/allcontent/supervisorWorkRecord',
                    name: 'supervisorWorkRecord',
                    component: resolve => require(['view/uses/supervisorWorkRecord/supervisorWorkRecord'], resolve),
                    meta: {
                        title: '教学督导工作记录表'
                    }
                },
                {
                    path: '/use/allcontent/supervisorWorkRecordUpdate',
                    name: 'supervisorWorkRecordUpdate',
                    component: resolve => require(['view/uses/supervisorWorkRecord/supervisorWorkRecord-update'], resolve),
                    meta: {
                        title: ''
                    }
                },
                {
                    path: '/use/allcontent/schoolQualityAnalysis',
                    name: 'schoolQualityAnalysis',
                    component: resolve => require(['view/uses/schoolQualityAnalysis/schoolQualityAnalysisList'], resolve),
                    meta: {
                        title: '学校质量分析',
                        keepAlive: true
                    }
                },
                {
                    path: '/use/allcontent/orgQualityAnalysis',
                    name: 'orgQualityAnalysis',
                    component: resolve => require(['view/uses/orgQualityAnalysis/orgQualityAnalysisList'], resolve),
                    meta: {
                        title: '开课部门教学质量分析',
                        keepAlive: true
                    }
                }
            ]
        },
        {
            path: '/use/home2',
            meta: {
                title: ''
            },
            name: 'home2',
            component: resolve => require(['view/uses/home2'], resolve),
            children: [
                {
                    path: '/use/allcontent/aiShcoolAnalysis/:type',
                    name: 'useAiShcoolAnalysis',
                    meta: {
                        title: '学校教学质量分析',
                        back: true
                    },
                    component: () => import('@/view/uses/schoolQualityAnalysis/ai-shcool-analysis.vue')
                },
                {
                    path: '/use/allcontent/aiSecondaryCollegeAnalysis/:type',
                    name: 'useAiSecondaryCollegeAnalysis',
                    meta: {
                        title: 'AI 开课部门教学质量分析',
                        back: true
                    },
                    component: () => import('@/view/uses/orgQualityAnalysis/ai-secondary-college-analysis.vue')
                },
                {
                    path: '/use/allcontent/aiTeacherTeachingAnalysis/:type',
                    name: 'useAiTeacherTeachingAnalysis',
                    meta: {
                        title: 'AI 教师教学质量分析',
                        back: true
                    },
                    component: () => import('@/view/uses/tchQualityAnalysis/ai-teacher-teaching-analysis.vue')
                }
            ]
        },
        {
            // 数据导出中心
            path: '/dataExportCenter/:id',
            name: 'qualityEvaluationTableList',
            component: () => import('@/view/supervising/components/qualityEvaluation/tableList')
        },
        // 教师问卷调查
        {
            path: '/tch-questionnaire',
            meta: {
                title: '教师问卷',
                keepAlive: false
            },
            name: 'center',
            component: resolve => require(['view/tchQuestionnaire/tch-questionnaire.vue'], resolve)
        },
        // 个人中心
        {
            path: '/center/home',
            meta: {
                title: '首页',
                keepAlive: true
            },
            name: 'center',
            component: resolve => require(['view/center/home'], resolve)
        }
    ]
}
export default new Router(routes)



// WEBPACK FOOTER //
// ./src/router/index.js